import AccordionV2 from "@components/Accordion/AccordionV2";
import EventsAwardsAccordionHeader from "@events-awards/EventsAwardsAccordionHeader";

/**
 * Component to render preference section for FAQ Page
 */
const Preference = (): React.ReactElement => {
  return (
    <div
      className="bg-gray-150 font-public-sans"
      data-testid="preference-component"
    >
      <AccordionV2
        testId="launch"
        className="border-none py-2"
        headerChildren={
          <EventsAwardsAccordionHeader
            title="Will preference be given to organisations involved in a particular sector, i.e. manufacturing?"
            className="px-0 font-medium"
          />
        }
        arrowClassName="h-auto w-auto -rotate-90 mr-6 border-none"
        isArrowRight
      >
        <p className="m-0 px-6 pb-2 pt-4">
          All business sectors are important to Singapore&apos;s continued
          growth. As such, we do not confine the awards to any particular sector
          or industry.
        </p>
      </AccordionV2>
    </div>
  );
};

export default Preference;
